
/**
 * site-wide logo carousel funcitonality.
 */
jQuery(function($){
    var options = {
        fx: 'carousel',
        easing: 'linear',
        slides: '> .item',
        speed: 3000,
        timeout: 1
    };
    if ('undefined' != typeof _site && _site.debug_backstop) options.paused = true;
    $('.logo-carousel .items').cycle(options);
});
